/* eslint-disable no-console */
import { LockOutlined, PhoneOutlined } from "@ant-design/icons";
import React from "react";
import { notification } from "antd";
import { useDispatch } from "react-redux";
import { Alert, Form, Input, Logo } from "../../atoms";
import { ModalWrapper } from "../../../common/modals/ModalWrapper";
import { closeModal } from "../../../redux/data/modals/modalReducer";
import { checkUserPoedInFirestore } from "../../../firestore/firestoreService";
import { listenToSelectedCustomer14860 } from "../../../redux/data/customer14860/customer14860Actions";
import { InputCheckBoxField } from "../../molecules";
import { LoginLogoWrapper } from "./LoginForm.style";
const partnerNameGr = process.env.REACT_APP_PARTNER_NAME_GR;
const logoUrl = process.env.REACT_APP_SITE_LOGO;
export const LoginFormPoed: React.FC = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [, forceUpdate] = React.useState({});

  // To disable submit button at the beginning.
  React.useEffect(() => {
    forceUpdate({});
  }, []);

  const handleSubmit = async () => {
    try {
      const values: any = await form.validateFields();
      setLoading(true);
      const customer = await checkUserPoedInFirestore(
        values.idNumber,
        values.phone,
      );

      dispatch(listenToSelectedCustomer14860(customer));
      localStorage.setItem("poedUserId", `${values.idNumber}-${values.phone}`);
      setLoading(false);
      dispatch(closeModal());
      notification.success({
        message: `Καλωσορίσατε στην ${partnerNameGr} πύλη`,
        description: "Έχετε συνδεθεί επιτυχώς",
      });
    } catch (errorInfo: any) {
      console.log({ errorInfo });
      setLoading(false);
      setError(`Παρουσιάστηκε πρόβλημα με τη ταυτοποίηση μέλους στον Αριθμό Τηλεφώνου ή το ΑΚΑ που καταχωρήσατε.
Παρακαλώ δοκιμάστε ξανά κι εάν εξακολουθεί να υπάρχει πρόβλημα στείλτε μας email στο poed@poupas.com.cy`);
    }
  };
  return (
    <ModalWrapper
      {...props}
      onSave={handleSubmit}
      loading={loading}
      closable={false}
      okText={"Σύνδεση"}
    >
      <LoginLogoWrapper>
        <Logo />
        <div className="header-pasydy-logo-name">για</div>
        <img className="header-pasydy-logo" src={logoUrl} alt="" />
      </LoginLogoWrapper>
      {error !== "" && (
        <Alert message={error} type="error" style={{ marginBottom: 20 }} />
      )}
      <Form form={form} name="horizontal_login" layout="vertical">
        <div style={{ color: "#faa11c", marginBottom: 20 }}>
          Οι προσφορές του Poupas for Holidays για {partnerNameGr} είναι μόνο
          για τα μέλη της {partnerNameGr}. Παρακαλώ συμπληρώστε τα πιο κάτω
          στοιχεία ώστε να επιβεβαιώσουμε το μέλος και να προχωρήσετε στις
          προσφορές.{" "}
        </div>

        <Form.Item
          name="phone"
          label="Αριθμός τηλεφώνου"
          rules={[
            {
              required: true,
              message: "Αριθμός τηλεφώνου",
            },
          ]}
        >
          <Input
            prefix={<PhoneOutlined className="site-form-item-icon" />}
            placeholder="Αριθμός τηλεφώνους"
          />
        </Form.Item>

        <Form.Item
          name="idNumber"
          label="ΑΚΑ"
          rules={[
            {
              required: true,
              message: "ΑΚΑ",
            },
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="ΑΚΑ"
          />
        </Form.Item>
        <InputCheckBoxField
          label=""
          name="accept"
          rules={[
            {
              required: true,
              message: "Συμφωνώ με τους Όρους και Προϋποθέσεις",
            },
          ]}
          options={[
            {
              label: (
                <>
                  Συμφωνώ με τους Όρους και{" "}
                  <a
                    href="https://www.poupas.com.cy/terms"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Προϋποθέσεις
                  </a>
                </>
              ),
              value: "YES",
            },
          ]}
        />
      </Form>
    </ModalWrapper>
  );
};
